import { createSelector } from 'reselect'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import getSelectedMediaIndexFromSelectedVariantGiftSelectUtil from 'modules/gift/redux/selectors/get-media-index-from-selected-variant/utils'
import getCurrentVariantProductSelect from 'modules/product/redux/selectors/get-current-variant'

const getSelectedMediaIndexFromSelectedVariantGiftSelect = createSelector(
  getCurrentVariantProductSelect,
  getSelectedVariantSelect,
  /**
   * @param {ProductVariantCollection} currentVariant
   * @param {ProductVariantCollection} selectedVariant
   */
  (
    currentVariant,
    selectedVariant
  ) => getSelectedMediaIndexFromSelectedVariantGiftSelectUtil({
    currentVariant,
    selectedVariant
  })
)

export default getSelectedMediaIndexFromSelectedVariantGiftSelect
